import { Flow } from 'signup-constants/Flow';
import { getIsMobile } from '../utils/deviceUtils';
import { SignupEmbedder } from 'signup-embedder';
import { getIsChatBotEnabledByLanguage } from './getIsChatBotEnabledByLanguage';
export const shouldShowChatBot = ({
  flowKey,
  isSU0004Variation = false
}) => {
  const isChatbotEnabledByLanguage = getIsChatBotEnabledByLanguage();
  const isMobile = getIsMobile();
  const isEmbedded = SignupEmbedder.isActive();

  // the flow in side panel layout shouldn't expect to show chatbot
  // Currently, only these two flows are not in side panel layout, plus SU0004 variation
  const allowedFlows = [Flow.HubSpotPartners, Flow.HubspotForStartups];
  const isAllowedFlow = allowedFlows.includes(flowKey);

  // TODO: Commerce chatbot not configured in portals 53 and 995353 (used for ATs) for /signup-hubspot/commerce.
  // Once the HubSpot Conversations chatflow is set up for that URL, remove this exclusion.
  return flowKey !== Flow.Commerce && !isMobile && (isAllowedFlow || isSU0004Variation) && isChatbotEnabledByLanguage && !isEmbedded;
};